// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/add_circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/delete.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

body {
    display: grid;
    grid-template-columns: auto 1fr;
    min-height: 100vh;

    --background-color: #ffffff;
    --text-color: #000000;

    background-color: var(--background-color);
    color: var(--text-color);
}

body>* {
    width: 100%;
    padding: 15px;
}

main {
    display: flex;
    flex-direction: column;
    align-items: center;
}

section {
    flex: 1;
    width: 100%;
    max-width: 1400px;
    padding: 15px;
}

li {
    list-style-type: none;
}

/* Sidebar */
aside {
    min-width: 200px;
    padding-left: 24px;
    border-right: 1px solid rgba(150, 150, 150, 0.3);

    background-color: var(--background-color);
}

aside #add-task {
    margin: 24px 0;
    font-size: 1.1rem;
}

aside li {
    padding-top: 8px;
}

aside #all-projects {
    font-size: 1.4rem;
    font-weight: bold;
    border: none;
    padding: 4px 36px 4px 2px;
}

#all-projects:hover {
    background: none;
}

aside .project-btn {
    font-weight: 500;
    font-size: 1.1rem;
    width: 100%;
    max-width: 18ch;
    overflow-wrap: break-word;
    text-align: start;
    appearance: none;
    border: none;
    background: none;
    cursor: pointer;

    padding: 6px 12px;
}

aside .project-btn:hover {
    background-color: rgba(150, 150, 150, 0.1);
}

#add-project {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: cover;
    border: none;
    height: 24px;
    width: 24px;
    border-radius: 10px;
}

aside div {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Main */
main {
    position: relative;
}

#section-1 {
    display: flex;
}

div.todo-item {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;

    padding: 8px 12px;
    margin: 12px 0;
    width: 350px;
    border: 1px solid rgba(150, 150, 150, 0.3);
    border-radius: 6px;
}

div.todo-item.priority-high {
    border-color: red;
}

div.todo-item.priority-medium {
    border-color: yellow;
}

.todo-isComplete {
    height: 1em;
    width: 1em;
    cursor: pointer;
    appearance: none;
    border: 1px solid #000000;
    border-radius: 10px;
    background-color: var(--background-color);
}

.todo-isComplete:hover {
    background-color: rgba(150, 150, 150, 0.3);
}


.todo-title {
    margin-right: 24px;
    cursor: pointer;
}

.todo-dueDate {
    font-size: 0.9rem;
    font-style: italic;
}


.btn {
    padding: 8px 12px;
    appearance: none;
    background: none;
    border: 1px solid rgba(150, 150, 150, 0.5);
    cursor: pointer;
}

.btn:hover {
    background-color: rgba(0, 0, 0, 0.1);
}


.form-container {
    position: absolute;
    top: 24px;
    left: 8px;

    background-color: white;
    border: 1px solid black;
    border-radius: 2px;
    padding: 48px 24px 24px;

    .form-buttons {
        position: absolute;
        top: 8px;
        right: 8px;
        display: flex;
        gap: 8px;
    }

    .close-form {
        padding: 0;
        border: none;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        height: 24px;
        width: 24px;
    }

    #delete-todo {
        padding: 0;
        border: none;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
        height: 24px;
        width: 24px;
    }
}

#new-task-form,
#view-edit-todo {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-size: 1.2rem;

    div {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 10px;
    }

    input {
        appearance: none;
        outline: none;
    }

    input,
    select {
        width: 175px;
        background: none;
        border: 2px solid rgba(150, 150, 150, 0.5);
        padding: 4px;
    }

    select {
        cursor: pointer;
    }

    input:focus {
        border: 2px solid blue;
    }

    button {
        margin-top: 8px;
        align-self: flex-end;
    }

    .buttons {
        display: flex;
        justify-content: space-between;
        gap: 36px;
    }

    .buttons>* {
        flex: 1;
    }
}

.hidden {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,iBAAiB;;IAEjB,2BAA2B;IAC3B,qBAAqB;;IAErB,yCAAyC;IACzC,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gDAAgD;;IAEhD,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;;IAEf,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yDAA8C;IAC9C,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,SAAS;AACT;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;;IAET,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;;AAGA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;;IAET,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;;IAEvB;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,yDAAyC;QACzC,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,yDAA0C;QAC1C,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;;IAEjB;QACI,aAAa;QACb,+BAA+B;QAC/B,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;;QAEI,YAAY;QACZ,gBAAgB;QAChB,0CAA0C;QAC1C,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,OAAO;IACX;AACJ;;AAEA;IACI,aAAa;AACjB","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    min-height: 100vh;\n\n    --background-color: #ffffff;\n    --text-color: #000000;\n\n    background-color: var(--background-color);\n    color: var(--text-color);\n}\n\nbody>* {\n    width: 100%;\n    padding: 15px;\n}\n\nmain {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\nsection {\n    flex: 1;\n    width: 100%;\n    max-width: 1400px;\n    padding: 15px;\n}\n\nli {\n    list-style-type: none;\n}\n\n/* Sidebar */\naside {\n    min-width: 200px;\n    padding-left: 24px;\n    border-right: 1px solid rgba(150, 150, 150, 0.3);\n\n    background-color: var(--background-color);\n}\n\naside #add-task {\n    margin: 24px 0;\n    font-size: 1.1rem;\n}\n\naside li {\n    padding-top: 8px;\n}\n\naside #all-projects {\n    font-size: 1.4rem;\n    font-weight: bold;\n    border: none;\n    padding: 4px 36px 4px 2px;\n}\n\n#all-projects:hover {\n    background: none;\n}\n\naside .project-btn {\n    font-weight: 500;\n    font-size: 1.1rem;\n    width: 100%;\n    max-width: 18ch;\n    overflow-wrap: break-word;\n    text-align: start;\n    appearance: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n\n    padding: 6px 12px;\n}\n\naside .project-btn:hover {\n    background-color: rgba(150, 150, 150, 0.1);\n}\n\n#add-project {\n    background-image: url('../src/add_circle.svg');\n    background-position: center;\n    background-size: cover;\n    border: none;\n    height: 24px;\n    width: 24px;\n    border-radius: 10px;\n}\n\naside div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* Main */\nmain {\n    position: relative;\n}\n\n#section-1 {\n    display: flex;\n}\n\ndiv.todo-item {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 12px;\n\n    padding: 8px 12px;\n    margin: 12px 0;\n    width: 350px;\n    border: 1px solid rgba(150, 150, 150, 0.3);\n    border-radius: 6px;\n}\n\ndiv.todo-item.priority-high {\n    border-color: red;\n}\n\ndiv.todo-item.priority-medium {\n    border-color: yellow;\n}\n\n.todo-isComplete {\n    height: 1em;\n    width: 1em;\n    cursor: pointer;\n    appearance: none;\n    border: 1px solid #000000;\n    border-radius: 10px;\n    background-color: var(--background-color);\n}\n\n.todo-isComplete:hover {\n    background-color: rgba(150, 150, 150, 0.3);\n}\n\n\n.todo-title {\n    margin-right: 24px;\n    cursor: pointer;\n}\n\n.todo-dueDate {\n    font-size: 0.9rem;\n    font-style: italic;\n}\n\n\n.btn {\n    padding: 8px 12px;\n    appearance: none;\n    background: none;\n    border: 1px solid rgba(150, 150, 150, 0.5);\n    cursor: pointer;\n}\n\n.btn:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n\n.form-container {\n    position: absolute;\n    top: 24px;\n    left: 8px;\n\n    background-color: white;\n    border: 1px solid black;\n    border-radius: 2px;\n    padding: 48px 24px 24px;\n\n    .form-buttons {\n        position: absolute;\n        top: 8px;\n        right: 8px;\n        display: flex;\n        gap: 8px;\n    }\n\n    .close-form {\n        padding: 0;\n        border: none;\n        background-image: url('../src/close.svg');\n        height: 24px;\n        width: 24px;\n    }\n\n    #delete-todo {\n        padding: 0;\n        border: none;\n        background-image: url('../src/delete.svg');\n        height: 24px;\n        width: 24px;\n    }\n}\n\n#new-task-form,\n#view-edit-todo {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    font-size: 1.2rem;\n\n    div {\n        display: grid;\n        grid-template-columns: 1fr auto;\n        gap: 10px;\n    }\n\n    input {\n        appearance: none;\n        outline: none;\n    }\n\n    input,\n    select {\n        width: 175px;\n        background: none;\n        border: 2px solid rgba(150, 150, 150, 0.5);\n        padding: 4px;\n    }\n\n    select {\n        cursor: pointer;\n    }\n\n    input:focus {\n        border: 2px solid blue;\n    }\n\n    button {\n        margin-top: 8px;\n        align-self: flex-end;\n    }\n\n    .buttons {\n        display: flex;\n        justify-content: space-between;\n        gap: 36px;\n    }\n\n    .buttons>* {\n        flex: 1;\n    }\n}\n\n.hidden {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
